import { Fragment } from 'react';
import { MARK_CLASSES, splitHighlights } from '../../utils/splitHighlights';

interface HighlightedTextProps {
  text: string | null | undefined;
  term: string;
}

/**
 * Renders the search term inside a plain-text field as `<mark>`. The segments
 * become React text nodes rather than an HTML string, so a term made of markup
 * stays text and never needs sanitising.
 *
 * Only exact substrings are marked. A row that Fuse matched through a typo or
 * a field the list does not show therefore carries no mark at all — deliberate,
 * because Fuse's match indices point into the markup-stripped text of the rich
 * text fields and would land in the wrong place there.
 */
export default function HighlightedText({ text, term }: HighlightedTextProps) {
  if (!text) return null;

  return (
    <>
      {splitHighlights(text, term).map((segment, index) =>
        segment.match ? (
          <mark key={index} className={MARK_CLASSES}>
            {segment.text}
          </mark>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
